"use client";
import { Box, List } from "@chakra-ui/react";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
type GetStartedProps = {
  title: string;
  desc: { text: string; highlight?: string }[];
  connection: { text: string; command: string };
  installation?: { heading: string; text: string; location: string | string[] };
  ports?: {
    heading: string;
    text: string;
    list: string[];
  };
  note: string;
};

const GetStarted = (props: GetStartedProps) => {
  const { title, desc, connection, installation, ports, note } = props;
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();
  return (
    <Box
      maxW={"5xl"}
      mx="auto"
      p={6}
      bg="white"
      borderRadius="md"
      className="brand-shadow"
    >
      <Heading variant={HeadingVariant} mb={8}>
        {title}
      </Heading>
      {desc.map((item, index) => (
        <Box key={index} mb={2} color="text.100">
          <Text variant={TextVariant} as="span">
            {item.text}
          </Text>
          {item.highlight && (
            <Text variant={TextVariant} as="span" fontWeight="600">
              {" "}
              {item.highlight}
            </Text>
          )}
        </Box>
      ))}
      {connection && (
        <Box mt={8}>
          <Text variant={TextVariant} color="text.100">
            {connection.text}
          </Text>
          <Text bg="gray.100" w="fit-content" borderRadius="md" p={2}>
            {connection.command}
          </Text>
        </Box>
      )}
      {installation && (
        <Box mt={8}>
          <Text variant={TextVariant} fontWeight={600} color="text.100" mb={1}>
            {installation.heading}
          </Text>
          <Text as="span" variant={TextVariant} mt={6} color="text.100">
            {installation.text}
          </Text>{" "}
          {Array.isArray(installation.location) ? (
            <List.Root mt={2} ml={4}>
              {installation.location.map((loc, index) => (
                <List.Item key={index} fontStyle={"italic"} fontWeight={550}>
                  {loc}
                </List.Item>
              ))}
            </List.Root>
          ) : (
            <Text as="span" fontStyle={"italic"} fontWeight={550}>
              : {installation.location}
            </Text>
          )}
        </Box>
      )}
      {ports && (
        <Box mt={8}>
          <Text variant={TextVariant} fontWeight={600} color="text.100" mb={1}>
            {ports.heading}
          </Text>
          <Text as="span" variant={TextVariant} mt={4} color="text.100">
            {ports.text}
          </Text>{" "}
          <List.Root mt={2} ml={4}>
            {ports.list.map((item, index) => (
              <Text key={index} variant={TextVariant} as="li" color="text.100">
                {item}
              </Text>
            ))}
          </List.Root>
        </Box>
      )}
      <Text mt={4} fontStyle="italic" color="gray.500">
        {note}
      </Text>
    </Box>
  );
};

export default GetStarted;
